<template>
  <div>
    <section>
      <div class="inner row5">
        <div class="title">
          <h1>FAQ 관리</h1>
        </div>
        <section>
          <div class="row4">
            <div class="aRow5">
              <div class="flex flexAlignS bdBttom">
                <div class="detailInputBox titleWrap">
                  <label><span class="QIcon"></span></label>
                  <input
                    ref="question"
                    v-model="question"
                    placeholder="질문을 입력해주세요."
                    maxlength="85"
                  />
                </div>
              </div>
              <div class="AIconTitleBox">
                <p>
                  <span class="AIcon"></span>
                </p>
              </div>
              <div class="detailTxtBox">
                <textarea
                  class="detailTxtBoxItem"
                  placeholder="답변을 입력해주세요."
                  v-model="answer"
                ></textarea>
              </div>
            </div>

            <div class="btnBox">
              <button @click="listBtnGo()" class="redborderBtn">취 소</button>
              <button class="redBtn" @click="faqSubmit">
                {{ submitText }}
              </button>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "@/axios/axios";

export default {
  name: "fAQManagementWrite",
  created() {
    this.detailFaqInfo();
  },
  data() {
    return {
      idx: this.$route.params.idx,
      submitText: "등 록",
      question: "",
      answer: "",
    };
  },
  methods: {
    listBtnGo() {
      this.$router.push("/FAQ");
    },
    faqSubmit() {
      let idx = this.idx;
      let question = this.question;
      let answer = this.answer;
      let confirmText = "등록";

      if (idx) {
        confirmText = "수정";
      }

      if (!question) {
        this.$alert("알림", "질문을 작성해주세요.");
        return false;
      }

      if (!answer) {
        this.$alert("알림", "답변을 입력해주세요.");
        return false;
      }

      var response = this.$createConfirmResponse();
      this.$confirm(
        "알림",
        `FAQ ${confirmText}하시겠습니까?`,
        "확인",
        "취소",
        response,
        {
          closed: () => {
            if (response.result) {
              let paramDatas = { idx: idx, question: question, answer: answer };
              axios
                .post("/api/admin/faq/submit", paramDatas)
                .then((result) => {
                  if (result.status == 200) {
                    this.$alert("알림", `FAQ ${confirmText}되었습니다.`, "", {
                      closed: () => {
                        this.$router.push({
                          name: "fAQManagementDetail",
                          params: { idx: result.data.IDX },
                        });
                      },
                    });
                  } else {
                    this.$alert("알림", `FAQ ${confirmText}실패하였습니다.`);
                  }
                })
                .catch((error) => {
                  this.$alert(
                    "알림",
                    `FAQ ${confirmText}실패하였습니다. <br>` +
                      error.response.data.error
                  );
                });
            }
          },
        }
      );
    },
    detailFaqInfo() {
      let idx = this.$route.params.idx;
      var param = {
        IDX: idx,
      };
      if (idx) {
        axios
          .post("/api/admin/faq/getFaqInfo", param)
          .then((response) => {
            if (response.status == 200) {
              let faq = response.data.FAQ;
              this.question = faq.QUESTION;
              this.answer = faq.ANSWER;
              this.submitText = "수 정";
            }
          })
          .catch(() => {})
          .then(() => {});
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
